import {useNavigate} from 'react-router-dom'
import LoadingBackdrop from '../../components/LoadingBackdrop'
import {useEffect} from 'react'

export default function HomeRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/')
  }, [])

  return (
    <>
      <LoadingBackdrop loading={true}/>
    </>

  )
}
